import { format, parseISO } from 'date-fns';
import dayjs from 'dayjs';

export function formatEventDate(dateString) {

    if (!dateString) return '';

    // parseISO: Converts an ISO 8601 formatted string into a JavaScript Date object.
    const date = parseISO(dateString);

    // format: Formats the given date according to the specified format string.
    return format(date, 'EEE, dd MMM yyyy');
}

export function formatSlotDate(dateString) {
    return dayjs(dateString, 'DD/MM/YYYY').format('ddd, DD MMM YYYY');
}

// Used in only event card component to display the date in 'dd MMM' format
export function formatDayMonth(dateString) {

    // Guard against null/undefined/empty
    if (!dateString) return { day: '', month: '' };

    const date = parseISO(dateString);
    return {
        day: format(date, 'dd'),
        month: format(date, 'MMM')
    }; // Returns the formatted date string in 'dd MMM' format
}

// Format time from "HH:mm:ss" to "HH:mm", using provided date
export function formatEventTime(dateString, timeString) {
    if (!dateString || !timeString) return "";

    const dateTime = dayjs(`${dateString} ${timeString}`, "YYYY-MM-DD HH:mm:ss");
    return dateTime.isValid() ? dateTime.format("HH:mm") : "";
}

export function formatDateTime(dateTimeString) {
    if (!dateTimeString) return "";

    const dateTime = dayjs(dateTimeString, "YYYY-MM-DD HH:mm");
    return dateTime.isValid() ? dateTime.format("ddd, DD MMM YYYY HH:mm") : "";
}

export function formatToYYYYMMDDHHMM(date) {
    return dayjs(date).format('YYYY-MM-DD HH:mm');
}